import "ngVue";
import "ngVue/build/plugins.js";

// @ts-ignore
const ngVueComponentsModule: any = angular.module("ngVueComponents", [
    "ngVue",
    "ngVue.plugins",
]);

export default ngVueComponentsModule;
